import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { resendVerificationEmail } from '../contexts/db.User';
import { translations } from '../translations';
import '../styles/pages/Auth.css';

function VerificationPending({ language }) {
  const [resendStatus, setResendStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get language from location state or props
  const currentLanguage = location.state?.language || language || 'fr';
  const t = translations[currentLanguage] || translations.en;
  
  // Get email from location state passed during redirect
  const email = location.state?.email;
  const userId = location.state?.userId;

  const handleResendEmail = async () => {
    if (!email || !userId) {
      setResendStatus({
        success: false,
        message: t.missingInformation || 'Missing email information'
      });
      return;
    }

    try {
      setLoading(true);
      const response = await resendVerificationEmail(email, userId);
      
      if (response && response.success) {
        setResendStatus({
          success: true,
          message: t.verificationEmailResent || 'Verification email has been resent'
        });
      } else {
        setResendStatus({
          success: false,
          message: response.message || t.resendFailed || 'Failed to resend verification email'
        });
      }
    } catch (error) {
      console.error('Error resending verification email:', error);
      setResendStatus({
        success: false,
        message: t.resendError || 'An error occurred while resending the email'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-content centered">
        <div className="verification-pending-container">
          <h1>{t.verifyYourEmail || 'Verify Your Email'}</h1>
          
          <div className="verification-message">
            <p>
              {t.verificationEmailSent || 'A verification email has been sent to'} 
              <strong> {email || t.yourEmailAddress || 'your email address'}</strong>.
            </p>
            <p>
              {t.verificationInstructions || 'Please check your inbox and click the verification link to complete your registration.'}
            </p>
          </div>

          <div className="verification-actions">
            <button 
              className="resend-button" 
              onClick={handleResendEmail}
              disabled={loading}
            >
              {loading 
                ? (t.sending || 'Sending...') 
                : (t.resendVerificationEmail || 'Resend Verification Email')}
            </button>
            
            <button 
              className="secondary-button" 
              onClick={() => navigate('/login')}
            >
              {t.backToLogin || 'Back to Login'}
            </button>
          </div>

          {resendStatus && (
            <div className={`resend-status ${resendStatus.success ? 'success' : 'error'}`}>
              {resendStatus.message}
            </div>
          )}

          <div className="verification-note">
            <p>
              {t.didNotReceiveEmail || "Didn't receive the email?"} 
              {t.checkSpamFolder || " Please check your spam folder or try resending the verification email."}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerificationPending;
